import * as types from './mutation-types'

import api from '../../../api/users.js'

function orderedUsers(items) {
  return items.sort(function compare(a, b) {
    if (a.lastName + a.firstName < b.lastName + b.firstName) return -1;
    if (a.lastName + a.firstName > b.lastName + b.firstName) return 1;
    return 0;
  })
}

export const getAllUsers = async ({ commit, dispatch }) => {
  try {
    var data = await api.getAllUsers();
    commit(types.USERS_GET_ALL, orderedUsers(data.data));
  }
  catch (e) {
    let msg = "There was an error getting the users."
    dispatch('showError', msg, { root: true })
    throw msg;
  }
}

export const getAllUsersByRole = async ({ commit, dispatch }, roleID) => {
  try {
    var data = await api.getAllUsersByRole(roleID);
    commit(types.USERS_GET_ALL, orderedUsers(data.data));
  }
  catch (e) {
    let msg = "There was an error getting the users."
    dispatch('showError', msg, { root: true })
    throw msg;
  }
}

export const getUserByID = async ({ commit, dispatch }, userid) => {
  try {
    var data = await api.getUserByID(userid);
    commit(types.SET_SELECTED_USER, data.data);
  }
  catch (e) {
    let msg = "There was an error getting the user."
    dispatch('showError', msg, { root: true })
    throw msg;
  }
}

export const setSelectedUser = ({ commit }, user) => {
  commit(types.SET_SELECTED_USER, user)
}

export const getAllUserTypes = async ({ commit, dispatch }) => {
  try {
    var data = await api.getAllUserTypes();
    commit(types.USER_TYPES_GET_ALL, data.data);
  }
  catch (e) {
    let msg = "There was an error getting the user types."
    dispatch('showError', msg, { root: true })
    throw msg;
  }
}

export const getAllPermissions = async ({ commit, dispatch }) => {
  try {
    var data = await api.getAllPermissions();
    commit(types.PERMISSIONS_GET_ALL, data.data);
  }
  catch (e) {
    let msg = "There was an error getting the user permissions."
    dispatch('showError', msg, { root: true })
    throw msg;
  }
}

export const saveUser = async ({ commit, dispatch }, user) => {
  try {
    if (user.id === 0) {
      var result = await api.create(user);
      if (result.status != 200) {
        let msg = "There was an error saving the user."
        if (result.data.data.includes("Username is already in use in the remote database.")) {
          msg = "Username is already in use in the remote database.";
        }
        dispatch('showError', msg, { root: true })
      } else {
        commit(types.ADD_USER, result.data);
      }
      return result;
    } else {
      var result = await api.update(user);
      if (result.status != 200) {
        let msg = "There was an error saving the user.";
        if (result.data.data.includes("Username is already in use in the remote database.")) {
          msg = "Username is already in use in the remote database.";
        }
        dispatch('showError', msg, { root: true });
      } else {
        commit(types.UPDATE_USER, user);
      }
      return result;
    }
  }
  catch (e) {
    console.log(e);
    let msg = "There was an error saving the user.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
}

export const importRemoteUser = async ({ commit, dispatch }, user) => {
  try {
    if (user.id === 0) {
      var result = await api.import(user)
      if (result.status != 200) {
        let msg = "There was an error importing the user."
        dispatch('showError', msg, { root: true })
      } else {
        commit(types.ADD_USER, result.data);
      }
      return result;
    } 
  }
  catch (e) {
    console.log(e);
    let msg = "There was an error importing the user."
    dispatch('showError', msg, { root: true })
    throw msg;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js